export interface IntegrationCatalogEntry {
  type: string;
  name: string;
  category: 'ehr' | 'practice_management' | 'telephony' | 'email';
  description: string;
  logoUrl?: string;
  authType?: 'credentials' | 'oauth' | 'oauth_client_credentials';
  fields: Array<{
    key: string;
    label: string;
    type: 'text' | 'number';
    required: boolean;
    placeholder?: string;
  }>;
}

export const INTEGRATION_CATALOG: IntegrationCatalogEntry[] = [
  {
    type: 'gmail',
    name: 'Google Gmail',
    category: 'email',
    description: 'Read and sync emails from Gmail using Google OAuth',
    logoUrl: '/integrations/gmail.svg',
    authType: 'oauth',
    fields: [],
  },
  {
    type: 'officeally',
    name: 'Office Ally',
    category: 'practice_management',
    description: 'Sync patients, appointments, and providers from Office Ally PM',
    logoUrl: '/integrations/officeally.png',
    authType: 'credentials',
    fields: [],
  },
  {
    type: 'athena',
    name: 'athenahealth',
    category: 'ehr',
    description: 'Connect to athenahealth for EHR data sync',
    logoUrl: '/integrations/athenahealth.svg',
    authType: 'oauth_client_credentials',
    fields: [
      {
        key: 'practiceId',
        label: 'athena practice ID',
        type: 'text',
        required: true,
        placeholder: 'e.g. 1959656',
      },
    ],
  },
  {
    type: 'practicefusion',
    name: 'Practice Fusion',
    category: 'ehr',
    description: 'Practice Fusion EHR integration for clinical data',
    logoUrl: '/integrations/practicefusion.svg',
    authType: 'credentials',
    fields: [],
  },
  {
    type: 'eclinicalworks',
    name: 'eClinicalWorks',
    category: 'ehr',
    description: 'eClinicalWorks EHR integration',
    logoUrl: '/integrations/eclinicalworks.webp',
    authType: 'credentials',
    fields: [],
  },
  {
    type: 'drchrono',
    name: 'DrChrono',
    category: 'ehr',
    description: 'DrChrono EHR integration',
    logoUrl: '/integrations/drchrono.png',
    authType: 'credentials',
    fields: [],
  },
];

export function getCatalogEntry(type: string): IntegrationCatalogEntry | undefined {
  return INTEGRATION_CATALOG.find((e) => e.type === type);
}
